import { ComposeStore } from './schema/ComposeStore';
import { ComposeViewState } from './schema/ComposeViewState';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import ComplianceConfiguration from 'owa-service/lib/contract/ComplianceConfiguration';
import MessageClassificationType from 'owa-service/lib/contract/MessageClassificationType';

const composeStoreData: ComposeStore = {
    viewStates: new ObservableMap<string, ComposeViewState>(),
    primaryComposeId: null,
    complianceConfigurations: new ObservableMap<string, ComplianceConfiguration>(),
    messageClassifications: new ObservableMap<string, MessageClassificationType>(),
    newMessageCreationInProgress: false,
};

export const getStore = createStore<ComposeStore>('compose', composeStoreData);

export const composeStore = getStore();
